<input hidden
       type="file"
       #fileInput
       multiple
       [accept]="accept"
       (change)="updateFiles($event)"
>
